<template>
<div>
    <v-btn text small @click.stop="displayDialog">
        <v-icon class="mr-2">fas fa-file-invoice</v-icon>
        Facturación.cl
    </v-btn>
    <v-dialog v-model="display" max-width="1200" persistent>
        <v-card min-height="300">
        <create-document
            :sales_note_id="sales_note"
            :allow_search_ot="!sales_note"
            @close="display=false"
            @issued="$emit('issued')"
        />
        </v-card>
    </v-dialog>
</div>
</template>
<script>
import CreateDocument from '@/components/facturacioncl/CreateDocument.vue'
export default {
    name: 'FacturacionClButton',
    components: { CreateDocument },
    props: {
        sales_note: { required: false, default: null }
    },
    data() {
        return { display: false }
    },
    methods: {
        displayDialog() {
            this.display = true
        }
    }
}
</script>
